module.exports = __webpack_public_path__ + "static/img/kol_logo_400.243dbb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kol_logo_400.png
// module id = AgJa
// module chunks = 1